// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventContextAction, FileList } from '@/audit/api/types';
import { Stack, Typography } from '@mui/material';

interface FileDifference {
  id: string;
  name: string;
  isOld: boolean;
  isNew: boolean;
}

interface Props {
  property: FileList;
  action: AuditEventContextAction;
}

export function AuditFileListLabel(props: Props) {
  const files: FileDifference[] = [];

  props.property.oldValue?.forEach(({ id, filename: name }) => {
    files.push({ id, name, isOld: true, isNew: false });
  });

  props.property.newValue?.forEach(({ id, filename: name }) => {
    const file = files.find((file) => file.id === id);

    if (file === undefined) {
      return files.push({ id, name, isOld: false, isNew: true });
    }

    file.isNew = true;
  });

  return (
    <Stack>
      <Typography component="span" variant="caption" fontWeight="bold">
        {props.property.name}:
      </Typography>
      {files.length > 0 ? (
        files.map(({ id, name, isNew, isOld }) => {
          if (isNew === isOld) {
            return null;
          }
          return (
            <Typography key={id} variant="caption" marginLeft={2}>
              <Typography component="span" variant="inherit">
                {name}
              </Typography>
              {props.action !== 'DELETE' && (
                <>
                  {' '}
                  <Typography
                    component="span"
                    variant="inherit"
                    sx={{ textDecoration: 'underline' }}
                  >
                    {isNew ? 'added' : 'removed'}
                  </Typography>
                </>
              )}
            </Typography>
          );
        })
      ) : (
        <Typography
          component="span"
          variant="caption"
          marginLeft={2}
          color="text.secondary"
        >
          None
        </Typography>
      )}
    </Stack>
  );
}
